const translate = {
    shared: {
        cancel: "Отмена",
        send: "Отправить",
        image: "Изображение",
        file: "Файл",
        location: "Местоположение",
    },
    chat: {
        askYourQuestion: "Задайте Ваш вопрос",
        enterYourMessage: "Введите ваше сообщение",
        you: "Вы",
        operator: "Оператор",
        system: "Система",
    },
};

export default translate;
